import React from "react"
import PropTypes from "prop-types"
import * as style from './achievement-card.module.scss'

const AcheivementsCard = ({image, heading, year, description}) => (
    <div className={style.card}>
        <div className={style.image}>
            <img src={image} alt={heading} />
        </div>
        <div className={style.content}>
            <h4>{heading}</h4>
            <h6 className={`letter-spaced-heading`}>{year}</h6>
            <p>{description}</p>
        </div>
    </div>
)

AcheivementsCard.propTypes = {
    image: PropTypes.string,
    heading: PropTypes.string,
    year: PropTypes.string,
    description: PropTypes.string,
}
  
AcheivementsCard.defaultProps = {
    heading: ``,
}

export default AcheivementsCard